// This component is used in components/common/dateselector.jsx
let Strings = {
    /**
     * Month Information
     */
    months: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ],
    shortMonths: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
    ],

    /**
     * Day Information
     */
    days: [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
    ],
    shortDays: [
        'S',
        'M',
        'T',
        'W',
        'T',
        'F',
        'S'
    ],

    /**
     * Properties
     */
    goToToday: 'Go to today',
    isRequiredErrorMessage: 'This field is required.',
    invalidInputErrorMessage: 'Invalid date format.'
};

export default Strings;


// WEBPACK FOOTER //
// ./src/components/common/dateselector/strings.jsx